import { SvgIcon, SvgIconProps} from '@mui/material';
import './ccf-acd-notification-indicator-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAcdNotificationIndicatorIconProps extends SvgIconProps  {}

/**
 * @example
 */
export function CcfAcdNotificationIndicatorIcon(
  props: CcfAcdNotificationIndicatorIconProps
) {
  return (
    <SvgIcon
      width="23"
      height="16"
      viewBox="0 0 23 16"
      fill="none"
      {...props}
    >
      <rect width="23" height="16" rx="8" fill="#007CBE" />
      <path
        d="M14.6133 13H8.625V11.7402L10.7754 9.56641C11.4121 8.91406 11.8281 8.46289 12.0234 8.21289C12.2188 7.95898 12.3594 7.72461 12.4453 7.50977C12.5312 7.29492 12.5742 7.07227 12.5742 6.8418C12.5742 6.49805 12.4785 6.24219 12.2871 6.07422C12.0996 5.90625 11.8477 5.82227 11.5312 5.82227C11.1992 5.82227 10.877 5.89844 10.5645 6.05078C10.252 6.20312 9.92578 6.41992 9.58594 6.70117L8.60156 5.53516C9.02344 5.17578 9.37305 4.92188 9.65039 4.77344C9.92773 4.625 10.2305 4.51172 10.5586 4.43359C10.8867 4.35156 11.2539 4.31055 11.6602 4.31055C12.1953 4.31055 12.668 4.4082 13.0781 4.60352C13.4883 4.79883 13.8066 5.07227 14.0332 5.42383C14.2598 5.77539 14.373 6.17773 14.373 6.63086C14.373 7.02539 14.3027 7.39648 14.1621 7.74414C14.0254 8.08789 13.8105 8.44141 13.5176 8.80469C13.2285 9.16797 12.7168 9.68555 11.9824 10.3574L10.8809 11.3945V11.4766H14.6133V13Z"
        fill="white"
      />
    </SvgIcon>
  );
}

export default CcfAcdNotificationIndicatorIcon;
